module.exports = __webpack_public_path__ + "static/media/img-boxfit-quote.ed51244f.png";